import { ShepherdService } from 'angular-shepherd';

// Factory function para criar os steps com as referências corretas do shepherdService
export const createTourSteps = (shepherdService: ShepherdService) => ({
    home: [
        {
            title: 'Bem-vindo!',
            text: 'Vamos te mostrar como utilizar o Otimiza.',
            buttons: [
                {
                    text: 'Próximo',
                    action: () => shepherdService.next(),
                }
            ]
        },
        {
            title: 'Menu lateral',
            text: 'No menu lateral você encontra todos os nossos recursos.',
            attachTo: {
                element: '.menu-passo',
                on: 'right',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
        {
            title: 'Suas informações',
            text: 'Aqui você encontra as informações da sua conta, CNPJ selecionado e plano assinado.',
            attachTo: {
                element: '.infos-passo',
                on: 'right',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
        {
            title: 'CNPJ Selecionado',
            text: 'Aqui é o seletor de CNPJ para utilizar das nossas ferramentas, clique para selecionar um CNPJ vinculado á sua conta.',
            attachTo: {
                element: '.cnpj-passo',
                on: 'right',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
        {
            title: 'Pronto!',
            text: 'Parabéns! Você pode começar a navegar pelo Otimiza.',
            buttons: [
                {
                    text: 'Finalizar',
                    action: () => shepherdService.complete()
                }
            ]
        }
    ],
    "cotar-produtos": [
        {
            title: 'Cotar produtos',
            text: 'Bem vindo à tela de cotação, aqui você pode cotar e comprar produtos de diversas distribuidoras.',
            scrollTo: false,
            buttons: [
                {
                    text: 'Próximo',
                    action: () => shepherdService.next(),
                }
            ]
        },
        {
            title: 'Pesquisa por produtos',
            text: 'Busque pelo produto pelo seu nome, EAN ou sintoma, ele vai mostrar uma lista, selecione o produto clicando nele.',
            attachTo: {
                element: '.pesquisaproduto-passo',
                on: 'bottom',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            scrollTo: false,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
        {
            title: 'Cotar produtos',
            text: 'Após selecionar todos os produtos que quer cotação, clique nesse botão "Buscar".',
            attachTo: {
                element: '.buscaproduto-passo',
                on: 'right',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            scrollTo: false,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
        {
            title: 'Melhores ofertas',
            text: 'Clique aqui caso prefira encontrar apenas a melhor oferta para o EAN selecionado.',
            attachTo: {
                element: '.melhoroferta-passo',
                on: 'bottom',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            scrollTo: false,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
        {
            title: 'Cotar utilizando arquivo',
            text: 'Você pode fazer a cotação a partir de um arquivo TXT ou CSV.',
            attachTo: {
                element: '.cotararquivo-passo',
                on: 'bottom',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            scrollTo: false,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
        {
            title: 'Histórico de ordens de compra',
            text: 'Clique aqui e veja um histórico de todas as suas ordens de compra.',
            attachTo: {
                element: '.historicoompra-passo',
                on: 'bottom',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            scrollTo: false,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
        {
            title: 'Status de cadastro',
            text: 'Clique aqui para verificar o seu status de cadastro nas indústrias.',
            attachTo: {
                element: '.statuscompra-passo',
                on: 'bottom',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            scrollTo: false,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
        {
            title: 'Pronto!',
            text: 'Caso tenha alguma dúvida de como utilizar o sistema de compras, assista o vídeo de cotação na página de tutoriais ou entre em contato com nossa equipe.',
            buttons: [
                {
                    text: 'Finalizar',
                    action: () => shepherdService.complete()
                }
            ]
        }
    ],
    "precificacao": [
        {
            title: 'Consulta de preço de produto.',
            text: 'Descubra qual preço praticar para o seu produto.',
            scrollTo: false,
            buttons: [
                {
                    text: 'Próximo',
                    action: () => shepherdService.next(),
                }
            ]
        },
        {
            title: 'Pesquisa por produtos',
            text: 'Busque pelo produto pelo seu nome, EAN ou sintoma, ele vai mostrar uma lista, selecione o produto clicando nele.',
            attachTo: {
                element: '.pesquisaproduto-passo',
                on: 'bottom',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            scrollTo: false,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
    ],
    "recomendacao": [
        {
            title: 'Recomendação de compra.',
            text: 'Diga qual o seu orçamento e te mostraremos as melhores recomendações de compra.',
            scrollTo: false,
            buttons: [
                {
                    text: 'Próximo',
                    action: () => shepherdService.next(),
                }
            ]
        },
        {
            title: 'Dados iniciais - CNPJ',
            text: 'Digite e selecione o CNPJ da farmácia que deseja consultar.',
            attachTo: {
                element: '.selecionar-cnpj-passo',
                on: 'bottom',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            scrollTo: false,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
        {
            title: 'Dados iniciais - Orçamento',
            text: 'Digite o seu orçamento desejado.',
            attachTo: {
                element: '.selecionar-orcamento-passo',
                on: 'bottom',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            scrollTo: false,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
        {
            title: 'Dados iniciais - Grupo de medicamentos',
            text: 'Digite o grupo de medicamentos desejado.',
            attachTo: {
                element: '.selecionar-grupo-medicamento-passo',
                on: 'bottom',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            scrollTo: false,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
        {
            title: 'Dados iniciais - Prioridade de compra',
            text: 'Selecione a prioridade de compra - ROI ou Fatia de mercado.',
            attachTo: {
                element: '.selecionar-prioridade-passo',
                on: 'bottom',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            scrollTo: false,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
        {
            title: 'Dados iniciais - Período de estoque',
            text: 'Digite o período de estoque desejado, ele pode ser entre 7 e 120 dias.',
            attachTo: {
                element: '.selecionar-periodo-passo',
                on: 'bottom',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            scrollTo: false,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
        {
            title: 'Dados iniciais - Agrupar moléculas',
            text: 'Selecione se deseja agrupar as moléculas na busca.',
            attachTo: {
                element: '.agrupar-moleculas-passo',
                on: 'bottom',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            scrollTo: false,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
        {
            title: 'Dados iniciais - Itens no estoque',
            text: 'Selecione se deseja ver os itens que já tem em estoque.',
            attachTo: {
                element: '.itens-estoque-passo',
                on: 'bottom',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            scrollTo: false,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
        {
            title: 'Dados iniciais - Consultar',
            text: 'Clique aqui quando terminar de preencher os dados e veja a recomendação de compra.',
            attachTo: {
                element: '.consultar-passo',
                on: 'bottom',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            scrollTo: false,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
    ],
    "chat": [
        {
            title: 'Iza, a assistente inteligente.',
            text: 'Nosso chat inteligente foi criado especialmente para facilitar o seu dia a dia dentro da farmácia. Ele funciona como um assistente virtual, sempre disponível para tirar dúvidas, agilizar atendimentos e ajudar em tarefas do cotidiano — tudo de forma simples, rápida e eficiente.',
            scrollTo: false,
            buttons: [
                {
                    text: 'Próximo',
                    action: () => shepherdService.next(),
                }
            ]
        },
        {
            title: 'Perguntas quebra gelo',
            text: 'Não sabe por onde começar? Clique em um dos cards com sugestões de mensagens.',
            attachTo: {
                element: '.quebra-gelo-passo',
                on: 'bottom',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            scrollTo: false,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
    ],
    "file-manager": [
        {
            title: 'Arquivos de Marketing.',
            text: 'Aqui você encontra imagens, vídeos, artes prontas e materiais promocionais desenvolvidos especialmente para ajudar a sua farmácia a se destacar nas redes sociais, campanhas de divulgação e ações com os clientes.',
            scrollTo: false,
            buttons: [
                {
                    text: 'Próximo',
                    action: () => shepherdService.next(),
                }
            ]
        },
        {
            title: 'Itens visíveis',
            text: 'Aqui mostra o número de itens ou pastas visíveis para você no momento.',
            attachTo: {
                element: '.resultados-passo',
                on: 'bottom',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            scrollTo: false,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
        {
            title: 'Navegação de pastas acessadas',
            text: 'Aqui você pode navegar pelas pastas e arquivos acessados.',
            attachTo: {
                element: '.breadcrumb-passo',
                on: 'bottom',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            scrollTo: false,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
        {
            title: 'Visualização por cards ou lista',
            text: 'Escolha se você quer ver os arquivos em forma de cards ou lista.',
            attachTo: {
                element: '.view-passo',
                on: 'bottom',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            scrollTo: false,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
        {
            title: 'Seus arquivos disponíveis',
            text: 'Aqui você encontra as pastas e arquivos disponíveis para a sua conta.',
            attachTo: {
                element: '.arquivos-passo',
                on: 'bottom',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            scrollTo: false,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
    ],
    "potencial-ponto-comercial": [
        {
            title: 'Potencial do ponto comercial.',
            text: 'Digite informações do endereço e tamanho de loja. Analizaremos a região e informações sobre os concorrentes e consumidores para auxiliá-lo a definir se o ponto comercial tem um bom potencial de faturamento.',
            scrollTo: false,
            buttons: [
                {
                    text: 'Próximo',
                    action: () => shepherdService.next(),
                }
            ]
        },
        {
            title: 'Dados do endereço.',
            text: 'Insira o endereço completo e o tamanho da loja.',
            attachTo: {
                element: '.potencial-passo',
                on: 'bottom',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            scrollTo: false,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
        {
            title: 'Dados da região',
            text: 'Te traremos todas as informações disponíveis da região.',
            attachTo: {
                element: '.ponto-info-passo',
                on: 'bottom',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            scrollTo: false,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        }
    ],
    "produtos-mais-vendidos": [
        {
            title: 'Produtos mais vendidos na sua micro região.',
            text: 'Tenha uma lista completa de produtos vendidos de acordo com informações do mercado. Certifique-se de ter o CNPJ selecionado para visualizar.',
            scrollTo: false,
            buttons: [
                {
                    text: 'Próximo',
                    action: () => shepherdService.next(),
                }
            ]
        },
        {
            title: 'Mapa da região.',
            text: 'Esse é o mapa com a sua microregião destacada.',
            attachTo: {
                element: '.map-passo',
                on: 'bottom',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            scrollTo: false,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
        {
            title: 'Pesquisa por produtos',
            text: 'Você pode procurar por um produto ou EAN específico para encontrar mais facilmente.',
            attachTo: {
                element: '.pesquisa-produto-passo',
                on: 'bottom',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            scrollTo: false,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
        {
            title: 'Lista de produtos mais vendidos',
            text: 'Aqui está a sua lista de produtos mais vendidos na micro região, com o nome, EAN e quantidade de itens vendidos. Você pode consultar sempre que quiser ou baixar essa lista de itens.',
            attachTo: {
                element: '.lista-produto-passo',
                on: 'bottom',
            },
            modalOverlayOpeningPadding: 16,
            modalOverlayOpeningRadius: 8,
            scrollTo: false,
            buttons: [
                {
                    text: 'Anterior',
                    action: () => shepherdService.back()
                },
                {
                    text: 'Próximo',
                    action: () => shepherdService.next()
                }
            ]
        },
    ],
});

export type StepsFeature = keyof ReturnType<typeof createTourSteps>;

// Mapeamento de rotas para features
export const ROUTE_TO_FEATURE_MAP: Record<string, StepsFeature> = {
    '/home': 'home',
    '/': 'home',
    '/cotar-produtos': 'cotar-produtos',
    // '/precificacao/consulta-produto': 'precificacao',
    // '/recomendacao': 'recomendacao',
    // '/ai/chat': 'chat',
    // '/file-manager': 'file-manager',
    // '/potencial-ponto-comercial': 'potencial-ponto-comercial',
    // '/produtos-mais-vendidos-regiao': 'produtos-mais-vendidos',
    // '/midas': 'midas',
    // '/midas/product': 'midas',
    // '/midas/pricing': 'midas',
    // '/midas/pricing-policy': 'midas'
};